<div class="home-page">
  <div class="home-logo">
    <img src="logo/vigimare-logo.png" alt="Vigimare" />
  </div>

  @if (canEditArea) {
    <section class="area-panel">
      <div class="area-header">
        <h2>Area of Interest</h2>

        @if (hasSavedArea()) {
          <button
            type="button"
            class="delete-area-btn"
            (click)="deleteArea()"
            [disabled]="deleting()"
          >
            {{ deleting() ? 'Deleting...' : 'Delete area' }}
          </button>
        }
      </div>

      @if (loading()) {
        <div class="state-message">Loading area preference...</div>
      }

      @if (validationErrors().length > 0) {
        <div class="validation-box">
          <strong>Area cannot be saved</strong>
          <ul>
            @for (validationError of validationErrors(); track validationError) {
              <li>{{ validationError }}</li>
            }
          </ul>
        </div>
      }

      @if (!loading()) {
        <form class="area-form" (ngSubmit)="saveArea()">
          <div class="preset-section">
            <span class="preset-label">Quick areas</span>

            <div class="preset-buttons">
              @for (preset of areaPresets; track preset.label) {
                <button
                  type="button"
                  class="preset-btn"
                  (click)="applyPreset(preset)"
                >
                  {{ preset.label }}
                </button>
              }
            </div>
          </div>

          <label>
            Min latitude
            <input
              type="number"
              step="0.000001"
              min="-90"
              max="90"
              name="minLatitude"
              [(ngModel)]="area.minLatitude"
              [class.invalid]="validationErrors().length > 0"
            />
          </label>

          <label>
            Max latitude
            <input
              type="number"
              step="0.000001"
              min="-90"
              max="90"
              name="maxLatitude"
              [(ngModel)]="area.maxLatitude"
              [class.invalid]="validationErrors().length > 0"
            />
          </label>

          <label>
            Min longitude
            <input
              type="number"
              step="0.000001"
              min="-180"
              max="180"
              name="minLongitude"
              [(ngModel)]="area.minLongitude"
              [class.invalid]="validationErrors().length > 0"
            />
          </label>

          <label>
            Max longitude
            <input
              type="number"
              step="0.000001"
              min="-180"
              max="180"
              name="maxLongitude"
              [(ngModel)]="area.maxLongitude"
              [class.invalid]="validationErrors().length > 0"
            />
          </label>

          <label class="checkbox-row">
            <input type="checkbox" name="enabled" [(ngModel)]="area.enabled" />
            Enable area filter
          </label>

          <label class="checkbox-row">
            <input
              type="checkbox"
              name="includeUnknownLocationAlerts"
              [(ngModel)]="area.includeUnknownLocationAlerts"
            />
            Show alerts without location
          </label>

          <div class="actions">
            <button type="submit" [disabled]="saving()">
              {{ saving() ? 'Saving...' : hasSavedArea() ? 'Update area' : 'Save area' }}
            </button>
          </div>
        </form>
      }

      @if (message()) {
        <div class="state-message success">{{ message() }}</div>
      }

      @if (error()) {
        <div class="state-message error">{{ error() }}</div>
      }
    </section>
  }
</div>
